import '@atlassian/aui/entry/aui.batch.prototyping';
import '../src/styles/index.less';
import '../src/scripts/index.js';
